/**
 * @file src/lib/head.tsx
 * @exports default (Head)
 * @summary Drop-in replacement for `next/head` backed by `react-helmet-async`.
 * @remarks Pages keep rendering `<Head><title>…</title></Head>`; the tags are hoisted into
 *          `document.head` by the `HelmetProvider` mounted in `src/App.tsx`.
 */

import type React from "react";
import { Helmet } from "react-helmet-async";

const Head = ({ children }: { children?: React.ReactNode }) => <Helmet>{children}</Helmet>;

export default Head;
